var React = require('react');

function CheckGreen (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"28.543","width":"25.4545","height":"25.4545","fill":"#55DF20","key":0}),React.createElement("path",{"d":"M12.2852 31.6351L20.4878 39.8677L38.136 22.1551","stroke":"#000E33","strokeWidth":"3","key":1}),React.createElement("circle",{"cx":"25.5028","cy":"30.7685","r":"23.9325","stroke":"#000E33","strokeWidth":"3","key":2})]);
}

CheckGreen.defaultProps = {"viewBox":"0 0 54 57","fill":"none"};

module.exports = CheckGreen;

CheckGreen.default = CheckGreen;
